import 'dotenv/config';

export const REACT_APP_NAME = process.env.REACT_APP_NAME;
export const REACT_APP_PAYPAL_ID = process.env.REACT_APP_PAYPAL_ID;
export const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
export const REACT_APP_SOCKET_URL = process.env.REACT_APP_SOCKET_URL;
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const REACT_APP_PAGE_SIZE = process.env.REACT_APP_PAGE_SIZE;
